import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-test-id"]

import { ComponentFields, ComponentRendering } from '@sitecore-jss/sitecore-jss/types/layout';
import ReviewSummary from './ReviewSummary.vue';
import { usePageStore } from '@/store';

// ----------------------------------------------------------------------------------
// Define variables
// ----------------------------------------------------------------------------------

export default /*@__PURE__*/_defineComponent({
  __name: 'ReviewPanel',
  props: {
    fields: {},
    rendering: {}
  },
  setup(__props: any) {

const props = __props;

const dataTestId = usePageStore().dataTestId(props.rendering);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", { "data-test-id": _unref(dataTestId) }, [
    _createVNode(ReviewSummary, {
      reviewSummaries: _ctx.fields.items,
      isConfirmationStep: false,
      disableExpandToggle: false,
      showDiscounts: true,
      title: _ctx.fields.title,
      isSelfService: true,
      heading: _ctx.fields.heading,
      belowHeading: _ctx.fields.belowHeading,
      subheading: _ctx.fields.subheading
    }, null, 8, ["reviewSummaries", "title", "heading", "belowHeading", "subheading"])
  ], 8, _hoisted_1))
}
}

})